import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";
import { downloadFile } from "../utils/file";

const usePreoffersList = ({company_id, page=1, per_page=10}) => {
  return useQuery(
    ['preoffers-list', page], 
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/preoffers`, {params: {page, per_page}})
    }, {
      keepPreviousData: true,
    }
  );  
}

const usePreoffer = ({preoffer_id}) => {
  return useQuery(
    ["preoffer", preoffer_id], 
    () => {
      return axiosClient
        .get(`/issuer/preoffers/${preoffer_id}`)
    }
  );
}

const usePreofferPitch = ({preoffer_id}) => {
  return useQuery(
    ["preoffer-pitch", preoffer_id],
    () => {
      return axiosClient
        .get(`/preoffers/${preoffer_id}/pitch`)
    }, {
      initialData: {},
    }
  );
}

const usePreofferSubscribersList = ({preoffer_id, page=1, per_page=25}) => {
  return useQuery(
    ['preoffer', 'subscribers-list', preoffer_id, page],
    () => {
      return axiosClient
        .get(`/issuer/preoffers/${preoffer_id}/subscribers.json`, {params: {page, per_page}})
    },
    {
      keepPreviousData: true,
    }
  );
}

const useExportPreofferSubscribersList = ({preoffer_id, opts={enabled: false}}) => {
  return useQuery(
    ['preoffer', preoffer_id, 'exportsubscriberlist'],
    () => {
      return axiosClient
        .get(`/issuer/preoffers/${preoffer_id}/subscribers.csv`)
    },
    {
      ...opts,
      cacheTime: 0,
      onSuccess: (data) => {
        downloadFile(data, `${preoffer_id}-subscribers.csv`)
      }
    }
  );
}

export {
  usePreoffersList,
  usePreoffer,
  usePreofferPitch,
  usePreofferSubscribersList,
  useExportPreofferSubscribersList,
}
